const monitorOptions = [
  { key: 'all', value: 'All Albums' },
  { key: 'future', value: 'Future Albums' },
  { key: 'missing', value: 'Missing Albums' },
  { key: 'existing', value: 'Existing Albums' },
  { key: 'first', value: 'Only First Album' },
  { key: 'latest', value: 'Only Latest Album' },
  { key: 'none', value: 'None' }
];

export default monitorOptions;
